<p class="mb-1">
  Ако по дадена обява е начислена такса за осъществена сделка, но реално <strong>не е била извършена продажба</strong>,
  може да подадете заявка за възстановяване на таксата. Това важи в следните случаи:
</p>
<ul>
  <li>Купувачът се е отказал след потвърждение на покупка;</li>
  <li>Не е осъществена комуникация, доставка или плащане;</li>
  <li>Сделката е прекратена по уважителни причини.</li>
</ul>
<h6 class="mt-3">1. Условия за подаване на заявка</h6>
<ul>
  <li>Заявки се подават <strong>не по-рано от 10 дни</strong> и <strong>не по-късно от 25 дни</strong> след сключване на
    сделката.
  </li>
  <li>По обявата <strong>не трябва да има доказателства за осъществена доставка</strong>.
  </li>
</ul>
<h6 class="mt-3">2. Как да подадете заявка?</h6>
<p>
  Заявката се подава чрез
  <a class="text-decoration-none" [routerLink]="[appRoutes.root, appRoutes.contactUs]">
    формата за контакт.
  </a>
</p>
<p class="mb-1">
  В текста на съобщението задължително включете:
</p>
<ul>
  <li>Линк към обявата;</li>
  <li>Кратко описание на причината за искането;</li>
  <li>Информация дали е имало контакт с купувача и какво е довело до прекратяване на сделката.</li>
</ul>
<h6 class="mt-3">3. Обработка на заявката</h6>
<p>
  Заявките се преглеждат от администратор в срок до <strong>5 календарни дни</strong>. Ако бъдат одобрени, начислената
  такса ще бъде възстановена по вашия <strong>потребителски портфейл</strong>.
</p>
<div class="alert alert-primary m-0">
  <strong>Съвет:</strong> Уверете се, че сте предоставили достатъчно информация. Колкото по-ясно и обосновано е
  искането, толкова по-бързо може да бъде обработено.
</div>
